(function () {
  const params = new URLSearchParams(window.location.search);
  const cartParam = params.get('recommended_cart');

  if (!cartParam) return;

  const itemsByVariantId = new Map();

  cartParam
    .split(',')
    .forEach((entry) => {
      const [id, quantity] = entry.split(':');
      const variantId = Number(id);
      const itemQuantity = Number(quantity || 1);

      if (!Number.isInteger(variantId) || variantId <= 0) return;
      if (!Number.isInteger(itemQuantity) || itemQuantity <= 0) return;

      const existingItem = itemsByVariantId.get(variantId);
      itemsByVariantId.set(variantId, {
        id: variantId,
        quantity: Math.max(existingItem?.quantity || 0, itemQuantity),
      });
    });

  const items = [...itemsByVariantId.values()];

  if (!items.length) return;

  if (window.millilayerRecommendedCartAddRunning) return;
  window.millilayerRecommendedCartAddRunning = true;

  const overlay = document.createElement('div');
  overlay.setAttribute('role', 'status');
  overlay.style.cssText = [
    'position:fixed',
    'inset:0',
    'z-index:2147483647',
    'display:flex',
    'align-items:center',
    'justify-content:center',
    'background:rgba(255,255,255,0.92)',
    'color:#282928',
    'font:600 16px/1.4 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif',
    'text-align:center',
    'padding:24px',
  ].join(';');
  overlay.textContent = 'Adding selected products to your cart...';
  document.documentElement.appendChild(overlay);

  params.delete('recommended_cart');
  const cleanUrl = `${window.location.pathname}${params.toString() ? `?${params.toString()}` : ''}${window.location.hash}`;
  window.history.replaceState({}, '', cleanUrl);

  const getCartSections = () => {
    try {
      return window.Alpine?.store('xCartHelper')?.getSectionsToRender?.().map((section) => section.id) || [];
    } catch (error) {
      return [];
    }
  };

  const openCartDrawer = () => {
    const cartButton = document.getElementById('cart-icon') || document.querySelector('[aria-controls="CartDrawer"]');
    if (cartButton) {
      cartButton.click();
    }
  };

  const removeOverlay = () => {
    overlay.remove();
  };

  const updateCartUi = (response) => {
    try {
      if (response?.sections && window.Alpine?.store('xCartHelper')) {
        window.Alpine.store('xCartHelper').reRenderSections(response.sections);
      }

      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      window.dispatchEvent(new CustomEvent('millilayer:recommended-cart-added', {
        detail: {items},
      }));
    } catch (error) {
      console.error(error);
    }
  };

  const fetchJson = async (url, options) => {
    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error(`Cart request failed (${response.status})`);
    }

    return response.json();
  };

  const addRecommendedItems = async () => {
    try {
      const sections = getCartSections();
      const root = window.Shopify?.routes?.root || '/';
      let cart = await fetchJson(`${root}cart.js`, {
        headers: {
          Accept: 'application/json',
        },
      });
      const itemsToAdd = [];
      let cartResponse = null;

      for (const item of items) {
        const existingLines = cart.items?.filter((cartItem) => cartItem.variant_id === item.id) || [];

        if (!existingLines.length) {
          itemsToAdd.push(item);
          continue;
        }

        const existingLine = existingLines.find((cartItem) => Object.keys(cartItem.properties || {}).length)
          || existingLines[0];
        const mergedQuantity = existingLines.reduce((total, cartItem) => total + cartItem.quantity, item.quantity);

        cartResponse = await fetchJson(`${root}cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            id: existingLine.key,
            quantity: mergedQuantity,
            ...(sections.length ? {sections} : {}),
          }),
        });
        cart = await fetchJson(`${root}cart.js`, {
          headers: {
            Accept: 'application/json',
          },
        });

        const duplicateLines = cart.items?.filter((cartItem) => (
          cartItem.variant_id === item.id && cartItem.key !== existingLine.key
        )) || [];

        for (const duplicateLine of duplicateLines) {
          cartResponse = await fetchJson(`${root}cart/change.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              id: duplicateLine.key,
              quantity: 0,
              ...(sections.length ? {sections} : {}),
            }),
          });
        }
        cart = await fetchJson(`${root}cart.js`, {
          headers: {
            Accept: 'application/json',
          },
        });
      }

      if (itemsToAdd.length) {
        cartResponse = await fetchJson(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: itemsToAdd,
            ...(sections.length ? {sections} : {}),
          }),
        });
      }

      updateCartUi(cartResponse);
      setTimeout(() => {
        removeOverlay();
        openCartDrawer();
      }, 250);
    } catch (error) {
      console.error(error);
      overlay.textContent = 'Opening cart...';
      window.location.href = `/cart/${items.map((item) => `${item.id}:${item.quantity}`).join(',')}`;
    }
  };

  if (document.readyState === 'loading') {
    window.addEventListener('load', addRecommendedItems, {once: true});
  } else {
    addRecommendedItems();
  }
})();
